import React from 'react';

const FrameworkMenuItem = ({ title, onClick, size = 12, selectedMenuItem, color = '#fcc75c' }) => (

  <p  style={{fontSize: size+'px', width:'fit-content', borderBottom:(selectedMenuItem === title ? `3px solid ${color}`:'0px')}} onClick={(e) => { e.preventDefault(); if (onClick) onClick(); }}>
    {title}
  </p>
);

export default FrameworkMenuItem;